import React from 'react';
import { useTheme } from '@mui/material';
import { ClientBrandIcon } from '@/components/icons/ClientBrandIcon';
import { getPipelineIcon } from '@/utils/constants';
import { useObjectContext } from '@/hooks/useObjectContext';
import { useGetClientContactData } from '@/hooks/useGetClientContactData';
import TabHeader from '@/components/layouts/TabHeader';
import { ProspectsIcon } from '@/components/icons/ProspectsIcon';
import { ClientIcon } from '@/components/icons/Client';

const ICON_PROPS = { width: '1.5em', height: '1.5em' };

const PreviewDrawerTabHeader = () => {
	const theme = useTheme();
	const { clientRow, clientId, dealRow, isClientView } = useObjectContext();
	const isProspect = clientRow?.isProspect;

	const { logoDomain, subtitle } = useGetClientContactData({
		clientRow,
		clientId,
	});

	const fallbackIconProps = {
		...ICON_PROPS,
		...(theme.palette.mode === 'dark' && { bgColor: 'transparent' }),
		...(!theme.palette.mode === 'dark' && !isProspect && { bgColor: '#34495E' }),
	};

	const Icon = isClientView ? (
		<ClientBrandIcon
			domain={logoDomain}
			{...ICON_PROPS}
			fallbackIcon={
				isProspect ? (
					<ProspectsIcon {...fallbackIconProps} />
				) : (
					<ClientIcon {...fallbackIconProps} />
				)
			}
		/>
	) : (
		getPipelineIcon(
			dealRow?.pipeline,
			ICON_PROPS.width,
			theme.palette.mode === 'dark' ? { bgColor: 'transparent' } : undefined,
		)
	);

	return (
		<TabHeader
			{...{
				subtitle: isClientView ? subtitle : '',
				icon: Icon,
				displayPolicyTotal: isClientView,
				isPreview: true,
			}}
			sx={{ px: 2 }}
		/>
	);
};
PreviewDrawerTabHeader.displayName = 'PreviewDrawerTabHeader';
export default PreviewDrawerTabHeader;
